import { ReportService } from 'src/app/reports/services/report.service';
import { Component, effect, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import {filter} from 'rxjs/operators';

import { actionIdConstants, commonContants, menuList } from '../../constants/common.contants';
import { SharedService } from '../../services/shared.service';
import { LanguagesEnum } from '../../models/enums/common.enum';
import { SideMenu } from '../../models/common.model';
import { GlobalContants } from '../../constants/global.contants';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../../services/api.service';
import { ContactSalesComponent } from '../contact-sales/contact-sales.component';
import { UserService } from '../../services/user.service';
import { activityPayload } from '../../models/userActivity.model';
import { StoreService } from '../../services/store.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
export class SideBarComponent implements OnInit {

  @Input("IsLoggedIn") isLoggedIn: boolean = false;

  collapseMenu$: boolean = true;
  langset: string = commonContants.defaultLanguage;
  currentLangID: number = LanguagesEnum.english;
  menuList = menuList;
  navigateID: number = 1;
  cityLang!:string;
  currentUrl: string = '';
  langList!:number;
  languageList:any;
  @Output() collapseToggle = new EventEmitter<any>();
  headerHide: boolean = false;
  reportId: number = 0;
  isMaintenanceBanner = false;
  maintenanceCities: any;
  maintenanceMessage: any;
  cityCode: any;

  constructor(
    private sharedService: SharedService,
    private router: Router,
    private dialog: MatDialog,
    private apiService: ApiService,
    private reportService: ReportService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private storeService: StoreService,
  ){
    effect(()=> {
      this.languageList = this.sharedService.languageList()
      this.langList = this.sharedService.languageList()?.length
  });

  }
  returnVal(lanId:number){
    if(lanId == LanguagesEnum.english && this.languageList.indexOf('en') > -1){
      return true;
    }
    if(lanId == LanguagesEnum.arabic && this.languageList.indexOf('ar') > -1){
      return true;
    }
    return false;
  }
  ngOnInit(): void {
    this.setLang();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: any) => {
        const url = document.location.pathname;
        this.headerHide = url === '' || url === '/';
        this.currentUrl = event.url;
        // this.navigateID = this.getNavigationUrl(this.currentUrl);
         this.reportId = this.activatedRoute.snapshot.queryParams['rid'];
      });
      this.collapseToggle.emit(this.collapseMenu$)
    this.fetchMaintenance();

    this.sharedService.cityChange$.subscribe((city) => {
    this.fetchMaintenance();
  });
  }
  ngAfterViewInit(){
    setTimeout(()=>{
      // this.setLang();
    }, 500)
  }

  check(menu:any){
    if((menu.routeUrl == '/AI-report')){
      if(this.apiService.checkResourceAccess('ai_report').GET){
        return true;
      }else{
        return false;
      }
    }else if(menu.routeUrl == '/generate-cache'){
      if(this.apiService.checkResourceAccess('generate_cache').GET){
        return true;
      }else{
        return false;
      }
    }
    return true;
  }
  setLang(){
    let currentLang = this.sharedService.getCurrentLangID();
    this.currentLangID = currentLang === 1 ? LanguagesEnum.arabic : LanguagesEnum.english;
    this.cityLang = `${this.sharedService.CityLang}`
  }

  collapseMenu(){
    this.collapseMenu$ = !this.collapseMenu$;
    this.collapseToggle.emit(this.collapseMenu$);

  }

  changeLang(lang: number){
    this.currentLangID = lang === 1 ? LanguagesEnum.arabic : LanguagesEnum.english;
    this.sharedService.setLanguage(lang, this.currentUrl)
        // Log user activity
    const activity:activityPayload = {
      userdata: { Languages: lang },
      actionId: actionIdConstants.change_language,
      entity: 'report',
      entityId: this.reportId,
    };
    this.userService.logUserActivity(activity);
  }
  menuflag=false;
  navigateMenu(menu: SideMenu){
    if(menu.index == 1) {
      this.menuflag = !this.menuflag;
      // this.navigateID = this.menuflag ? 1 : -1;
      this.reportService.reportQueryToggle$.next(this.menuflag);
      // if(this.menuflag && this.activatedRoute.snapshot.queryParams['rid']) return;
    }
    this.collapseMenu$ = true;
    this.collapseToggle.emit(this.collapseMenu$)
    this.navigateID = menu.index;
    const lang = this.sharedService.getCurrentLang() || 'en';
    const city = this.sharedService.getStoreValue(GlobalContants.StoreKey.Slug);
    const getReportUrl = this.sharedService.getStoreValue(GlobalContants.StoreKey.latestReportRoute);
    let updatedUrl = getReportUrl?.split('/').slice(2).join('/')
    if(menu.index === 1 && getReportUrl){
      this.router.navigateByUrl(`${city}-${lang}/${updatedUrl}`);
    } else {
      this.router.navigateByUrl(`${city}-${lang}${menu.routeUrl}`);
    }
  }

  getNavigationUrl(url: string){
    let formatUrl = url;
    if(url.includes('?')){
      const index = url.indexOf('?');
      formatUrl = url.substring(0,index)?.trim();
    }
    let match = null;
    let urlData = formatUrl.split('/');
    if(urlData.length > 1){
      match = this.menuList.find((name) => {
        return name.routeUrl === `/${urlData[2]}`
      })
    }
    return match ? match?.index : 0;
  }


  getHelp(){
    if(this.dialog.openDialogs.length > 0) return;
    this.dialog.open(ContactSalesComponent,{
      width: '600px',
      maxHeight: '95vh',
      panelClass: 'contact-form',
      data: { Type : 'contact_us'}
    })
  }
  closeMaintenance(){
    this.isMaintenanceBanner = false
  }

   fetchMaintenance() {
    this.sharedService.getMaintenanceStatus().subscribe({
      next: (res:any) => {
        this.cityCode = this.storeService.get(GlobalContants.StoreKey.placeCode);
        const CurrentLangID = String(this.storeService.get(GlobalContants.StoreKey.CurrentLangID) || '1');
       if(res.status == 200 && res.data?.length > 0){
         console.log(res);
        const parsedValue = JSON.parse(res.data[0].value);
        const messageData = parsedValue.message;
        this.maintenanceMessage = messageData;
        if (parsedValue.city == "null" || parsedValue.city.trim() == '' || parsedValue.city == null) {
        this.isMaintenanceBanner = true;
        }else{
        this.maintenanceCities = parsedValue.city.split(',').map((c: string) => c.trim().toLowerCase())
        this.isMaintenanceBanner = !!this.cityCode && this.maintenanceCities.includes(this.cityCode.toLowerCase());
          }
          console.log(parsedValue.message, parsedValue.city);

       }else{
         this.isMaintenanceBanner = false;
       }

      },
      error: (err) => {
        console.error('Error fetching API', err);
      }
    });
  }
}
